import { getProductField } from './getProductField';
import { type InternalProductInfoType } from './types';

export function buildProductFields(
	productInfo: InternalProductInfoType,
	productOverrides?: Partial<InternalProductInfoType>,
): any {
	const overrides = productOverrides || {};
	const env = getProductField(productInfo.env, overrides.env);
	const product = getProductField(productInfo.product, overrides.product);
	const subproduct = getProductField(productInfo.subproduct(), overrides.subproduct);
	const version = getProductField(productInfo.version, overrides.version);
	const origin = getProductField(productInfo.origin, overrides.origin);
	const platform = getProductField(productInfo.platform, overrides.platform);
	const ic = productInfo.ic; // ic should not be overriden once set
	const cdp = productInfo.cdp;
	const csp = productInfo.csp;

	return {
		env,
		product,
		subproduct,
		version,
		origin,
		platform,
		ic,
		cdp,
		csp,
	};
}
